/*!
 * Copyright (c) 2014 Simon Dyson
 * jQuery UI MsxiSlider 1.1.0
 *
 * This plugin is based on the work of Ben Olson:
 *
 * Copyright (c) 2012 Ben Olson (https://github.com/bseth99/jquery-ui-extensions)
 * jQuery UI LabeledSlider 1.0.12
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 *
 * Depends:
 *  jquery.ui.core.js
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 *  jquery.ui.slider.js
 */

(function ($, undefined) {

    $.widget("ui.msxislider", $.ui.slider, {

        version: "1.1.0",

        options: {
            tickInterval: null,
            labelInterval: null,
            tweenLabels: true,
            tickLabels: null,
            tickArray: [],
            showSelected: false,
            highlightedValueArray: []
        },

        uiSlider: null,
        tickInterval: null,
        labelInterval: null,
        tweenLabels: true,

        _create: function () {

            this._detectOrientation();

            if (this.options.tickInterval != null) {
                this.uiSlider =
                    this.element
                        .wrap('<div class="ui-slider-wrapper ui-widget"></div>')
                        .before('<div class="ui-slider-labels">')
                        .parent()
                        .addClass(this.orientation)
                        .css('font-size', this.element.css('font-size'));
            }

            this._super();

            if (this.options.tickInterval != null) {
                this.element.removeClass('ui-widget');

                this._alignWithStep();

                if (this.orientation == 'horizontal') {
                    this.uiSlider
                        .width(this.element.css('width'));
                } else {
                    this.uiSlider
                        .height(this.element.css('height'));
                }

                if(this.options.showSelected) {
                    this.uiSlider.find('.ui-slider-labels').addClass('show-selected');
                    this._on({
                        "msxisliderslide": function(event, ui) {
                            //noinspection JSPotentiallyInvalidUsageOfThis
                            this._drawLabels(ui.value);
                        }
                    });
                }

                this._drawLabels();
            }
        },

        _drawLabels: function (selectedVal) {
            var labels = this.options.tickLabels || {},
                $labelsContainer = this.uiSlider.children('.ui-slider-labels'),
                direction = this.orientation == 'horizontal' ? 'left' : 'bottom',
                min = this.options.min,
                max = this.options.max,
                tickInterval = this.tickInterval,
                labelInterval = this.labelInterval,
                tickCount = ( max - min ) / tickInterval,
                tickArray = this.options.tickArray,
                i = 0;

            $labelsContainer.html('');

            var selectedValue = this.options.showSelected ? (selectedVal !== undefined ? selectedVal : parseInt(this.option('value'))) : null;
            var highlightedValues = this.options.highlightedValueArray;
            var selected, highlighted, label, $label, value;
            var tickValues = [];
            if (tickArray.length > 0) {
                // tickArray provided, print labels only in the array
                for (i = 0; i < tickArray.length; i++) {
                    tickValues.push(tickArray[i]);
                }
            }
            else {
                for (; i <= tickCount; i++) {
                    tickValues.push(i * tickInterval + min);
                }
            }
            if(selectedValue !== null && tickValues.indexOf(selectedValue)==-1) {
                tickValues.push(selectedValue);
            }
            if(highlightedValues) {
                for (i = 0; i < highlightedValues.length; i++) {
                    if(tickValues.indexOf(highlightedValues[i])==-1) {
                        tickValues.push(highlightedValues[i]);
                    }
                }
            }

            for (i = 0; i < tickValues.length; i++) {
                value = tickValues[i];
                selected = selectedValue !== null && (value == selectedValue);
                highlighted = highlightedValues && ($.inArray(value, highlightedValues) != -1);
                label = tickArray.length > 0 || value % labelInterval == 0 || selected || highlighted
                    ? ( labels[value]
                        ? labels[value]
                        : (this.options.tweenLabels || selected || highlighted ? value : '') )
                    : '';
                $label = $('<div>').addClass('ui-slider-label-ticks')
                    .css(direction, (Math.round((value - min) / (max-min) * 10000) / 100) + '%')
                    .html('<span>' + label + '</span>');
                if(selected) {
                    $label.addClass('selected');
                }
                if(highlighted) {
                    $label.addClass('highlighted');
                }
                $label.appendTo($labelsContainer);
            }
        },

        _setOption: function (key, value) {

            this._super(key, value);

            if (this.tickInterval != null) {
                switch (key) {

                    case 'tickInterval':
                    case 'tickLabels':
                    case 'tickArray':
                    case 'min':
                    case 'max':
                    case 'step':

                        this._alignWithStep();
                        this._drawLabels();
                        break;

                    case 'orientation':

                        this.element
                            .removeClass('horizontal vertical')
                            .addClass(this.orientation);

                        this._drawLabels();
                        break;
                }
            }
        },

        _alignWithStep: function () {
            if (this.options.tickInterval < this.options.step) {
                this.tickInterval = this.options.step;
            }
            else {
                this.tickInterval = this.options.tickInterval;
            }

            if (this.options.labelInterval < this.tickInterval) {
                this.labelInterval = this.tickInterval;
            }
            else {
                this.labelInterval = this.options.labelInterval - this.options.labelInterval % this.tickInterval;
            }
        },

        _destroy: function () {
            this._super();
            if (this.tickInterval != null) {
                this.uiSlider.replaceWith(this.element);
            }
        },

        widget: function () {
            return this.tickInterval != null ? this.uiSlider : this._super();
        }

    });

}(jQuery));
